import styled from 'styled-components';

export const IconButtonWrapper = styled.div`
  min-height: 38px;
  height: 38px;
  width: 38px;
  min-width: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;
